document.addEventListener('variantChange', function(data) {
  
  let var_id = data.detail.variant.id;
  let option = document.querySelector("[data-var-id='" + var_id + "']");
  let quantity = option.getAttribute('data-quantity');
  let variant_inventory_count = document.querySelector(".variant-inventory");
  let variant_inventory_wrapper = document.querySelector("#variant-inventory > p");
  let variant_quantity_hidden = variant_inventory_wrapper.classList.contains('variant-inventory--hidden');
  
  variant_inventory_count.innerText = quantity;
  
  if ( quantity > 10 && !variant_quantity_hidden) {
    variant_inventory_wrapper.classList.add('variant-inventory--hidden');
  }
  
  if ( quantity <= 10 && variant_quantity_hidden) {
    variant_inventory_wrapper.classList.remove('variant-inventory--hidden');
  }
  
});